export enum SofView {
  LineHandling = 0,
  Nomination = 1,
  None = 2,
  NominationEdit = 3,
  WorkPacket = 4,
  AdditionalServices = 5,
}
